import React from 'react';
import TeamItem from '../../../components/Homepage/Team2/TeamItem2';
import { Col, Container, Image, Row } from 'react-bootstrap';
import img from "../../../assets/images/homepage/section-3/1-tracejado.svg";
import img2 from "../../../assets/images/jobs/section-3/3-tracejado.svg";
import Spinner from '../../UI/Spinner/Spinner';
import { Suspense } from 'react';
const Carousel = React.lazy(() => import('../../UI/Carousel/Carousel'));


const Team = props => {

    const rita_segurado1 = require('../../../assets/images/team/Rita_Segurado_1.png');
    const rita_segurado1Webp = require('../../../assets/images/team/Rita_Segurado_1.webp');
    const rita_segurado2 = require('../../../assets/images/team/Rita_Segurado_2.png');
    const rita_segurado2Webp = require('../../../assets/images/team/Rita_Segurado_2.webp');

    const erica1 = require('../../../assets/images/team/Erica_1.png');
    const erica1Webp = require('../../../assets/images/team/Erica_1.webp');
    const erica2 = require('../../../assets/images/team/Erica_2.png');
    const erica2Webp = require('../../../assets/images/team/Erica_2.webp');

    const leandra1 = require('../../../assets/images/team/Leandra_1.png');
    const leandra1Webp = require('../../../assets/images/team/Leandra_1.webp');
    const leandra2 = require('../../../assets/images/team/Leandra_2.png');
    const leandra2Webp = require('../../../assets/images/team/Leandra_2.webp');

    const inesPinho1 = require('../../../assets/images/team/Ines_Pinho_1.png');
    const inesPinho1Webp = require('../../../assets/images/team/Ines_Pinho_1.webp');
    const inesPinho2 = require('../../../assets/images/team/Ines_Pinho_2.png');
    const inesPinho2Webp = require('../../../assets/images/team/Ines_Pinho_2.webp');

    const duarteSilva1 = require('../../../assets/images/team/Duarte_Silva_1.png');
    const duarteSilva1Webp = require('../../../assets/images/team/Duarte_Silva_1.webp');
    const duarteSilva2 = require('../../../assets/images/team/Duarte_Silva_2.png');
    const duarteSilva2Webp = require('../../../assets/images/team/Duarte_Silva_2.webp');

    const catarina1 = require('../../../assets/images/team/Catarina_1.png');
    const catarina1Webp = require('../../../assets/images/team/Catarina_1.webp');
    const catarina2 = require('../../../assets/images/team/Catarina_2.png');
    const catarina2Webp = require('../../../assets/images/team/Catarina_2.webp');

    const marta1 = require('../../../assets/images/team/Marta_1.png');
    const marta1Webp = require('../../../assets/images/team/Marta_1.webp');
    const marta2 = require('../../../assets/images/team/Marta_2.png');
    const marta2Webp = require('../../../assets/images/team/Marta_2.webp');

    function changeTeam(e) {
        const team = document.getElementById("team-members")
        const sales = document.getElementById("sales-group")
        const recruitment = document.getElementById("recruitment-group")
        if (e.target.id === "sales") {
            team.classList.add("sales")
            team.classList.remove("recruitment")
            sales.classList.add("d-block")
            sales.classList.remove("d-none")
            recruitment.classList.add("d-none")
            recruitment.classList.remove("d-block")
        } else {
            team.classList.remove("sales")
            team.classList.add("recruitment")
            sales.classList.remove("d-block")
            sales.classList.add("d-none")
            recruitment.classList.remove("d-none")
            recruitment.classList.add("d-block")
        }

    }

    return (
        <section id="team" className="my Team">
            <Image src={img} className="img-dashed-t  d-none d-lg-block" />
            <h2 className="h4 text-center fw-600 black mb-0">
                {props.t("homepage:section-4.title")}
            </h2>

            <Container id='team-members' className='team-members'>
                {/* tabs text */}
                <Row className='tab-text-group'>
                    <Col xs={4} className="p-0 p-md-3 d-flex justify-content-center align-items-center">
                        <p className='tab-text fw-600' id='sales' onClick={e => { changeTeam(e) }}>{props.t("homepage:section-4.business")}</p>
                    </Col>
                    <Col xs={{ span: 4, offset: 4 }} className="p-0 p-md-3 d-flex justify-content-center align-items-center">
                        <p className='tab-text fw-600' id='recruitment' onClick={e => { changeTeam(e) }}>{props.t("homepage:section-4.recruitment")}</p>
                    </Col>
                </Row>
                {/* sales */}
                <Container id='sales-group' className='sales-group'>
                    {/* carousel sales */}
                    <div className='d-lg-none'>
                        <Suspense fallback={<Spinner />}>
                            <Carousel className="teamSlide">
                                <TeamItem
                                    quote1={props.t('homepage:section-4.quote-rita-segurado-1')}
                                    quote2={props.t('homepage:section-4.quote-rita-segurado-2')}
                                    email="rita.segurado@sysmatch.pt"
                                    name="Rita Segurado"
                                    position="Head of Sales"
                                    src1={rita_segurado1}
                                    src1Webp={rita_segurado1Webp}
                                    src2={rita_segurado2}
                                    src2Webp={rita_segurado2Webp}
                                    alt={props.t('homepage:section-4.rita-segurado_alt')}
                                />
                                <TeamItem
                                    quote1={props.t('homepage:section-4.quote-ines-pinho-1')}
                                    quote2={props.t('homepage:section-4.quote-ines-pinho-2')}
                                    email="ines.pinho@sysmatch.pt"
                                    name="Inês Pinho"
                                    position="Business Manager"
                                    src1={inesPinho1}
                                    src1Webp={inesPinho1Webp}
                                    src2={inesPinho2}
                                    src2Webp={inesPinho2Webp}
                                    alt={props.t('homepage:section-4.ines-pinho-alt')}
                                />
                                <TeamItem
                                    quote1={props.t('homepage:section-4.quote-erica-figueiredo-1')}
                                    quote2={props.t('homepage:section-4.quote-erica-figueiredo-2')}
                                    email="erica.figueiredo@sysmatch.pt"
                                    name="Erica Figueiredo"
                                    position="Business Manager"
                                    src1={erica1}
                                    src1Webp={erica1Webp}
                                    src2={erica2}
                                    src2Webp={erica2Webp}
                                    alt={props.t('homepage:section-4.erica-figueiredo_alt')}
                                />
                            </Carousel>
                        </Suspense>
                    </div>
                    <Row lg={3} className="px-4 d-none d-lg-flex">
                        <TeamItem
                            quote1={props.t('homepage:section-4.quote-rita-segurado-1')}
                            quote2={props.t('homepage:section-4.quote-rita-segurado-2')}
                            email="rita.segurado@sysmatch.pt"
                            name="Rita Segurado"
                            position="Head of Sales"
                            src1={rita_segurado1}
                            src1Webp={rita_segurado1Webp}
                            src2={rita_segurado2}
                            src2Webp={rita_segurado2Webp}
                            alt={props.t('homepage:section-4.rita-segurado_alt')}
                        />
                        <TeamItem
                            quote1={props.t('homepage:section-4.quote-ines-pinho-1')}
                            quote2={props.t('homepage:section-4.quote-ines-pinho-2')}
                            email="ines.pinho@sysmatch.pt"
                            name="Inês Pinho"
                            position="Business Manager"
                            src1={inesPinho1}
                            src1Webp={inesPinho1Webp}
                            src2={inesPinho2}
                            src2Webp={inesPinho2Webp}
                            alt={props.t('homepage:section-4.ines-pinho-alt')}
                        />
                        <TeamItem
                            quote1={props.t('homepage:section-4.quote-erica-figueiredo-1')}
                            quote2={props.t('homepage:section-4.quote-erica-figueiredo-2')}
                            email="erica.figueiredo@sysmatch.pt"
                            name="Erica Figueiredo"
                            position="Business Manager"
                            src1={erica1}
                            src1Webp={erica1Webp}
                            src2={erica2}
                            src2Webp={erica2Webp}
                            alt={props.t('homepage:section-4.erica-figueiredo_alt')}
                        />
                    </Row>
                </Container>
                {/* recruitment */}
                <Container id='recruitment-group' className='recruitment-group d-none'>
                    {/* carousel recruitment */}
                    <div className='d-lg-none'>
                        <Suspense fallback={<Spinner />}>
                            <Carousel className="teamSlide">
                                <TeamItem
                                    quote1={props.t('homepage:section-4.quote-leandra-1')}
                                    quote2={props.t('homepage:section-4.quote-leandra-2')}
                                    email="leandra.rabottini@sysmatch.pt"
                                    name="Leandra Rabottini"
                                    position="IT Recruiter"
                                    src1={leandra1}
                                    src1Webp={leandra1Webp}
                                    src2={leandra2}
                                    src2Webp={leandra2Webp}
                                    alt={props.t('homepage:section-4.leandra-alt')}
                                />
                                <TeamItem
                                    quote1={props.t('homepage:section-4.quote-duarte-silva-1')}
                                    quote2={props.t('homepage:section-4.quote-duarte-silva-2')}
                                    email="duarte.silva@sysmatch.pt"
                                    name="Duarte Silva"
                                    position="IT Recruiter"
                                    src1={duarteSilva1}
                                    src1Webp={duarteSilva1Webp}
                                    src2={duarteSilva2}
                                    src2Webp={duarteSilva2Webp}
                                    alt={props.t('homepage:section-4.duarte-silva-alt')}
                                />
                                <TeamItem
                                    quote1={props.t('homepage:section-4.quote-catarina-1')}
                                    quote2={props.t('homepage:section-4.quote-catarina-2')}
                                    email="catarina.varandas@sysmatch.pt"
                                    name="Catarina Varandas"
                                    position="IT Recruiter"
                                    src1={catarina1}
                                    src1Webp={catarina1Webp}
                                    src2={catarina2}
                                    src2Webp={catarina2Webp}
                                    alt={props.t('homepage:section-4.catarina-alt')}
                                />
                                <TeamItem
                                    quote1={props.t('homepage:section-4.quote-marta-1')}
                                    quote2={props.t('homepage:section-4.quote-marta-2')}
                                    email="marta.simoes@sysmatch.pt"
                                    name="Marta Simões"
                                    position="IT Recruiter"
                                    src1={marta1}
                                    src1Webp={marta1Webp}
                                    src2={marta2}
                                    src2Webp={marta2Webp}
                                    alt={props.t('homepage:section-4.marta-alt')}
                                />
                            </Carousel>
                        </Suspense>
                    </div>
                    <Row lg={3} className="px-4 d-none d-lg-flex">
                        <TeamItem
                            quote1={props.t('homepage:section-4.quote-leandra-1')}
                            quote2={props.t('homepage:section-4.quote-leandra-2')}
                            email="leandra.rabottini@sysmatch.pt"
                            name="Leandra Rabottini"
                            position="IT Recruiter"
                            src1={leandra1}
                            src1Webp={leandra1Webp}
                            src2={leandra2}
                            src2Webp={leandra2Webp}
                            alt={props.t('homepage:section-4.leandra-alt')}
                        />
                        <TeamItem
                            quote1={props.t('homepage:section-4.quote-duarte-silva-1')}
                            quote2={props.t('homepage:section-4.quote-duarte-silva-2')}
                            email="duarte.silva@sysmatch.pt"
                            name="Duarte Silva"
                            position="IT Recruiter"
                            src1={duarteSilva1}
                            src1Webp={duarteSilva1Webp}
                            src2={duarteSilva2}
                            src2Webp={duarteSilva2Webp}
                            alt={props.t('homepage:section-4.duarte-silva-alt')}
                        />
                        <TeamItem
                            quote1={props.t('homepage:section-4.quote-catarina-1')}
                            quote2={props.t('homepage:section-4.quote-catarina-2')}
                            email="catarina.varandas@sysmatch.pt"
                            name="Catarina Varandas"
                            position="IT Recruiter"
                            src1={catarina1}
                            src1Webp={catarina1Webp}
                            src2={catarina2}
                            src2Webp={catarina2Webp}
                            alt={props.t('homepage:section-4.catarina-alt')}
                        />
                        <TeamItem
                            quote1={props.t('homepage:section-4.quote-marta-1')}
                            quote2={props.t('homepage:section-4.quote-marta-2')}
                            email="marta.simoes@sysmatch.pt"
                            name="Marta Simões"
                            position="IT Recruiter"
                            src1={marta1}
                            src1Webp={marta1Webp}
                            src2={marta2}
                            src2Webp={marta2Webp}
                            alt={props.t('homepage:section-4.marta-alt')}
                        />
                    </Row>
                </Container>
            </Container>

            <Image src={img2} className="img-dashed-b d-none d-lg-block" />
        </section>
    );
}

export default Team;
